import { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Loading from "~/components/Loading";
import { ManifoldNextGenAppHeader } from "~/components/ManifoldNextGenAppHeader";
import { ManifoldNextGenSideNav } from "~/components/ManifoldNextGenSideNav";
import { NextGenHeaderProvider } from "~/contexts/nextgen-header";
import { useManifoldNextGenFeature } from "~/hooks/useManifoldNextGenFeature";
import { useUserPreferences } from "~/hooks/useUserPreferences";
import { ROUTE_404 } from "~/router/constants";

const DARK_MODE_KEY = "nextgen-dark-mode";

export function ManifoldNextGenLayout() {
  const feature = useManifoldNextGenFeature();
  const [preferences, updatePreferences] = useUserPreferences();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const [isDark, setIsDark] = useState(() => localStorage.getItem(DARK_MODE_KEY) === "true");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDark);
    localStorage.setItem(DARK_MODE_KEY, String(isDark));
  }, [isDark]);

  if (feature.isLoading) {
    return <Loading />;
  }

  if (!feature.enabled || !preferences.optedIntoManifoldNextGen) {
    return <Navigate to={ROUTE_404} replace />;
  }

  const handleSwitchToClassic = () => {
    updatePreferences({ optedIntoManifoldNextGen: false });
    navigate("/");
  };

  return (
    <NextGenHeaderProvider>
      <div data-theme="manifold-nextgen" className="flex h-screen bg-background text-foreground">
        <ManifoldNextGenSideNav
          collapsed={collapsed}
          onCollapsedChange={setCollapsed}
          isDark={isDark}
          onToggleDark={() => setIsDark((d) => !d)}
          onSwitchToClassic={handleSwitchToClassic}
        />

        <main className="flex min-w-0 flex-1 flex-col overflow-auto">
          <ManifoldNextGenAppHeader />
          <div className="flex-1 overflow-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </NextGenHeaderProvider>
  );
}
